const BaseComponent = require('common/home-block/extend');

const listTpl = Handlebars.templates['zcyEvE/comps/sasac-comps/templates/listTpl'];
class noticeComp extends BaseComponent {
  init () {
    super.init();
    this.$el.find('.js-nav-click').on('click',(e) => {
      const $this = $(e.target);
      const type = $this.attr('type');
      this.$el.find('.list-title .active').removeClass('active');
      this.$el.find(`.list-title [type=${type}]`).addClass('active');
      this.$el.find('.list-content.active').removeClass('active');
      this.$el.find(`.list-content[type=${type}]`).addClass('active');
      if(type == 'inquiry' || type == 'bidPrice') {
        this.ajaxFunc(type);
      }
    })
    window.onload = () => {
      const li=$('.download .list-content2 li');
      li.map((i,x) => {
        if (i>5){
          $(x).hide();
        }
      });
    }
  }

  ajaxFunc(type){
    const data = {
      district:"9004",
      pageSize:10,
      pageNo:1
    }
    //切换环境
    const urlObj = this.getUrl();
    const url = urlObj[type].ajaxUrl + '?' + $.param(data);
    $.ajax({
      url,
      type:'get'
    })
    .done(res=>{
      const resp = typeof res == 'string' ? JSON.parse(res) : null;
      const $ul = this.$el.find(`.js-rest-box[type=${type}]`);
      let newData = [];
      if (resp && resp.result && resp.result.total > 0) {
        resp.result.data.map((v) => {
          const newDate = new Date(v.pubDate);
          if (!newDate) {
            return v;
          }
          const publishDate = new Date(v.pubDate).getTime();
          publishDate && (v.publishDate = publishDate)
          return v;
        })
        newData = resp.result.data;
      }
      $ul.html(listTpl({_DATA_:newData,turnUrl:urlObj[type].turnUrl}))
    })
  }

  //根据环境获取地址
  getUrl() {
    const href = window.location.href;
    let env = '';
    href.indexOf('test') > 0 && (env = '.test');
    href.indexOf('staging') > 0 && (env = '-staging');
    let http = href.indexOf('test') > 0 ? 'http' : 'https';
    return {
      "bidPrice": {
        "ajaxUrl": '/api/core/remote/bidprice',
        "turnUrl": `${http}://reversehall${env}.zhengcaiyun.cn/reversehall/detail?requireId=`
      },
      "inquiry": {
        "ajaxUrl": '/api/core/remote/inquiry',
        "turnUrl": `${http}://inquiryhall${env}.zhengcaiyun.cn/inquiryhall/detail?announcementId=`
      }
    };
  }
}
module.exports = noticeComp;
